import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import * as _ from 'lodash'
import { ENV } from '../environment/environment'
import { UserModel } from "../models/user/user.model";
import { UserType } from "../enums/usertype.enum";

@Injectable({
  providedIn: "root",
})
export class ImpersonateWrapper {
      constructor(
        private authService: MsalService
    ) {
    }

    isOnImpersonateMode(user: UserModel): boolean {
      if (_.isEmpty(user.impersonateUser)) {
        return false
      }
      
      if (!_.isEmpty(user.impersonateUser.login)
          && !_.isNil(user.impersonateUser.user_id)
          && !_.isEmpty(user.impersonateUser.user_type_id)
          && (user.impersonateUser?.user_type_id === UserType.SUPER_ADMIN || user.impersonateUser?.user_type_id === UserType.SUPPORT)) {
        return true
      }

      return false;
    }

    isAbleToSubmitOrder(user: UserModel): boolean {
      if (!_.isEmpty(user.impersonateUser.login)
          && !_.isNil(user.impersonateUser.user_id)
          && !_.isEmpty(user.impersonateUser.user_type_id)
          && (user.impersonateUser?.user_type_id === UserType.SUPER_ADMIN)) {
        return true
      }

      return false;
    }
}


// WEBPACK FOOTER //
// ./src/infra/impersonateWrapper.ts